import { __assign } from "tslib";
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export var SvgNull = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 20 20", fill: "none" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M10 2.5l3.26 5.625 3.23 5.625H3.51l3.23-5.625L10 2.5z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { clipRule: "evenodd", d: "M15.303 4.697A7.5 7.5 0 114.697 15.303 7.5 7.5 0 0115.303 4.697z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }))); };
//# sourceMappingURL=Null.js.map